var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.wrapperClass},[(_vm.isMounted)?[_vm._t("default")]:[_c('span',{staticClass:"co-placeholder",class:_vm.placeholderClass,style:(_vm.placeholderStyle)},[_vm._v(_vm._s(_vm.placeholder))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }